/* eslint-disable max-params */
const createScopedApi = (baseURL, axiosInstance, customHeaders = {}, timeout) => ({
    get: (url, config = {}) =>
        axiosInstance.get(url, {
            baseURL,
            ...config,
            headers: {
                ...config.headers,
                ...customHeaders
            },
            timeout
        }),
    post: (url, data, config = {}) =>
        axiosInstance.post(url, data, {
            baseURL,
            ...config,
            headers: {
                ...config.headers,
                ...customHeaders
            },
            timeout
        }),
    put: (url, data, config = {}) =>
        axiosInstance.put(url, data, {
            baseURL,
            ...config,
            headers: {
                ...config.headers,
                ...customHeaders
            },
            timeout
        }),
    delete: (url, config = {}) =>
        axiosInstance.delete(url, {
            baseURL,
            ...config,
            headers: {
                ...config.headers,
                ...customHeaders
            },
            timeout
        }),
    patch: (url, data, config = {}) =>
        axiosInstance.patch(url, data, {
            baseURL,
            ...config,
            headers: {
                ...config.headers,
                ...customHeaders
            },
            timeout
        })
});

export default createScopedApi;
